import { render, staticRenderFns } from "./re-new-contract.vue?vue&type=template&id=11f85412&scoped=true"
import script from "./re-new-contract.vue?vue&type=script&lang=js"
export * from "./re-new-contract.vue?vue&type=script&lang=js"
import style0 from "./re-new-contract.vue?vue&type=style&index=0&id=11f85412&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f85412",
  null
  
)

export default component.exports